import Keycloak from "keycloak-js";
import type { AuthConfig } from "./types";

let instance: Keycloak | null = null;

/**
 * Retorna (ou cria) a instancia singleton do Keycloak.
 * Parametrizada por config para que cada app possa usar realm diferente
 * (ex: laudo-app → inbim, admin-app → master).
 */
export function getKeycloak(config: AuthConfig): Keycloak {
  if (!instance) {
    instance = new Keycloak({
      url: config.keycloakUrl,
      realm: config.realm,
      clientId: config.clientId,
    });
  }
  return instance;
}

/** Reset para testes. */
export function _resetKeycloak(): void {
  instance = null;
}
